import React from "react";
import classnames from "classnames";
import "./styles.less";

export const Search = (props) => {
  const { className, icon, button, onSearch, ...restProps } = props;
  const cls = classnames({
    "blog-input": true,
    [className]: !!className,
  });
  const componentProps = {
    ...restProps,
    className: cls,
  };
  return (
    <div className="blog-search">
      <input {...componentProps}></input>
      {icon && (
        <div onClick={onSearch} className="blog-icon">
          <i className="icon authing-icon authing-search icon-style"></i>
        </div>
      )}
    </div>
  );
};
